/**
 * `/merchandising/styles/$styleId/materials` — Sourcing (formerly
 * "Materials"), one of the Style File's 7 process screens (garment Increment
 * 5, M2). Route path is unchanged from `/styles/$styleId/materials` — only
 * the module prefix moved — so links from `inward-page.tsx` don't need
 * updating beyond the prefix.
 *
 * @see docs/product/garment-os-screen-build-plan.md §A
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { StyleMaterialsPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/styles/$styleId/materials")({
  component: StyleMaterialsRoute,
});

function StyleMaterialsRoute() {
  const { styleId } = Route.useParams();
  return (
    <WorkspaceShell
      breadcrumbs={[
        { label: "Merchandising", to: "/" },
        { label: "Style files", to: "/merchandising/styles" },
        { label: "Sourcing" },
      ]}
      contentClassName="max-w-none"
      viewportClassName="p-0 md:p-0"
    >
      <StyleMaterialsPage styleId={styleId} />
    </WorkspaceShell>
  );
}
